import { resolvePayrollHourlyRate } from "./payrollRateResolution";

/**
 * Immutable employee fields snapshotted onto timelogs at creation time.
 */
export function buildEmployeeSnapshot(actor = {}) {
  const employeeId = actor.supabase_user_id || actor.user_id || null;

  return {
    employee_id: employeeId,
    employee_name: actor.employee_name || "",
    trade_id: actor.trade_id || null,
    trade_name: actor.trade_name || "",
    classification_name: actor.classification_name || "",
    payroll_type: actor.payroll_type || "",
    hourly_rate: Number(actor.hourly_rate) || 0,
  };
}

/**
 * Map snapshot fields to time_logs column names.
 */
export function snapshotToTimelogFields(snapshot = {}) {
  return {
    supabase_user_id: snapshot.employee_id,
    user_id: snapshot.employee_id,
    employee: snapshot.employee_name,
    trade_id: snapshot.trade_id,
    trade_name: snapshot.trade_name,
    classification_name: snapshot.classification_name,
    payroll_type: snapshot.payroll_type,
    hourly_rate: snapshot.hourly_rate,
  };
}

/**
 * Rebuild a rate-resolution actor from a stored time_logs row
 * so edits can re-resolve hourly_rate without changing employee identity.
 */
export function actorFromTimelogRow(log = {}) {
  return {
    supabase_user_id: log.supabase_user_id || log.user_id || null,
    user_id: log.user_id || log.supabase_user_id || null,
    employee_name: log.employee || "",
    trade_id: log.trade_id || null,
    trade_name: log.trade_name || "",
    classification_name: log.classification_name || "",
    payroll_type: log.payroll_type || "",
    hourly_rate: Number(log.hourly_rate) || 0,
  };
}

/**
 * Resolve payroll rate + return the full timelog employee snapshot.
 */
export async function resolveTimelogEmployeeSnapshot(
  actor = {},
  {
    supabase,
    payrollType = null,
    supabaseUserId = null,
  } = {},
) {
  const base = buildEmployeeSnapshot(actor);
  const effectivePayrollType = payrollType || base.payroll_type || "";

  const resolution = await resolvePayrollHourlyRate({
    supabase,
    actor,
    tradeId: base.trade_id,
    tradeName: base.trade_name,
    classificationName: base.classification_name,
    payrollType: effectivePayrollType,
    supabaseUserId: supabaseUserId || base.employee_id,
    cachedHourlyRate: base.hourly_rate,
  });

  return {
    ...base,
    payroll_type: resolution.payrollType || effectivePayrollType,
    classification_name:
      resolution.classificationName || base.classification_name,
    hourly_rate: resolution.hourlyRate,
    trade_id: resolution.tradeId ?? base.trade_id,
    trade_name: resolution.tradeName || base.trade_name,
    missingCustomRate: resolution.missingCustomRate,
  };
}
